import { IDelivery } from './models';

export default class DeliveryHelper {
    public static getUniqueDeliveries(deliveries: IDelivery[]): IDelivery[] {
      let uniqueDeliveries: IDelivery[] = [];
      const reduced = deliveries.reduce(function(m, d){
        if(!m[d.bilagsnummer]){
          m[d.bilagsnummer] = {...d, count: 1};
          return m;
        }
        
        m[d.bilagsnummer].fuktighet += d.fuktighet;
        m[d.bilagsnummer].plast += d.plast;
        m[d.bilagsnummer].lignin += d.lignin;
        m[d.bilagsnummer].aske += d.aske;
        m[d.bilagsnummer].count += 1;
        return m;
     },{});
     uniqueDeliveries= Object.keys(reduced).map(function(bilagsnummer){
         const item  = reduced[bilagsnummer];
         const test  = item 

         test.fuktighet= item.fuktighet > 0 ? item.fuktighet/item.count : null;
         test.plast= item.fuktighet > 0 ? item.plast/item.count : null;
         test.lignin= item.fuktighet > 0 ? item.lignin/item.count : null;
         test.aske=  item.fuktighet > 0 ? item.aske/item.count: null;
         return test
      })
    return uniqueDeliveries;
  }
}